class LazyLoad {
  constructor() {
    this.init();
  }

  init() {
    window.addEventListener('DOMContentLoaded', () => {
      let pageImages = [...document.querySelectorAll('img[data-src]:not([data-not-lazy])'), ...document.querySelectorAll('[data-lazy-background]')];
      let notLazyImages = [...document.querySelectorAll('img[data-src][data-not-lazy]')];

      if (notLazyImages.length) {
        for (let image of notLazyImages) {
          preloadImage(image);
        }
      }

      if (!pageImages) return;

      if ('IntersectionObserver' in window) {
        let observer = new IntersectionObserver((entries, self) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              let element = entry.target;
              if (element.hasAttribute('data-lazy-background')) {
                preloadBackgroundImage(element);
              } else if (element.hasAttribute('data-src')) {
                preloadImage(element);
              }
              self.unobserve(element);
            }
          });
        }, {
          rootMargin: '200px 0px 200px 0px',
        });
  
        pageImages.forEach(image => {
          observer.observe(image);
        });
      } else {
        lazyLoadFallback();
        document.addEventListener('scroll', lazyLoadFallback);
      }

      function lazyLoadFallback() {
        let scrollTop = window.scrollY || document.documentElement.scrollTop;
        for (let image of pageImages) {
          if ((scrollTop + window.innerHeight) > (image.getBoundingClientRect().top + scrollTop)) {
            if (image.hasAttribute('data-lazy-background')) {
              preloadBackgroundImage(image);
              removeImageFromList(image);
            } else if (image.hasAttribute('data-src')) {
              preloadImage(image);
              removeImageFromList(image);
            }
          }
        }
      }
    
      function removeImageFromList(image) {
        let imageIndex = pageImages.indexOf(image);
        pageImages.splice(imageIndex, 1);
        if (pageImages.length === 0) {
          document.removeEventListener('scroll', lazyLoadFallback);
        }
      }

      function preloadImage(element) {
        let source = element.getAttribute('data-src');
        element.setAttribute('src', source);
        element.removeAttribute('data-src');
      }
    
      function preloadBackgroundImage(element) {
        element.style.backgroundImage = `url('${ element.getAttribute('data-lazy-background') }')`;
        element.removeAttribute('data-lazy-background');
      }
    });
  }
}

export default new LazyLoad();


// WEBPACK FOOTER //
// ./src/js/lazy-load.js